export const projectsData = [{
        "id": 1,
        "name": "Readmos - JS Library",
        "autors": ["arre[code]"],
        "description": "Show the README.md of any Github repository in your web.",
        "image": require("./images/readmos.png").default,
        "technologies": ["Javascript", "Github REST API", "HTML", "CSS", "Bootstrap 5"],
        "reponame": "readmos",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/readmos/master/README.md",
    },
    {
        "id": 2,
        "name": "arre[code] - Web Page",
        "autors": ["arre[code]"],
        "description": "My ReactJS Web Portfolio",
        "image": require("./images/arrecode.png").default,
        "technologies": ["ReactJS", "CSS", "Javascript ES6", "React Bootstrap"],
        "reponame": "arrecode",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/arrecode/master/README.md",
    },
    {
        "id": 3,
        "name": "Trovo - Web Page",
        "autors": ["arre[code]"],
        "description": "ReactJS Web for traveling enterprise",
        "image": require("./images/trovowebpage.png").default,
        "technologies": ["ReactJS", "React Hooks", "React Router", "HTML", "JSX", "CSS"],
        "reponame": "trovo",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/trovo/master/README.md",
    },
    {
        "id": 4,
        "name": "Pixnotes - Web Application",
        "autors": ["arre[code]"],
        "description": "Python Web Application for taking notes, with login/register system, authentication and SQL database. Styled with Bootstrap and NES.css.",
        "image": require("./images/pixnotes.png").default,
        "technologies": ["ReactJS", "React Hooks", "React Router", "HTML", "JSX", "CSS"],
        "reponame": "trovo",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/pixnotes/master/README.md",
    },
    {
        "id": 5,
        "name": "Dreamel Web Site - Web Page",
        "autors": ["arre[code]"],
        "description": "Example Web Page for Traveling made in Gatsby",
        "image": require("./images/dreamel.png").default,
        "technologies": ["Gatsby", "GraphQL", "CSS"],
        "reponame": "trovo",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/dreamel/master/README.md",
    },
    {
        "id": 6,
        "name": "MG Construcciones - Web Page",
        "autors": ["arre[code]", "Enzo Camera"],
        "description": "On development ReactJS website for a construction enterprise",
        "image": require("./images/mgconstrucciones.png").default,
        "technologies": ["ReactJS", "CSS", "Javascript ES6", "React Animations", "Gallery Framework", "React Bootstrap", "Responsive", "Graphic Design", "UI Design"],
        "reponame": "trovo",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/mg-construcciones/master/README.md",
    },
    {
        "id": 7,
        "name": "Maxmin Project - Currency analysis software ",
        "autors": ["arre[code]", "German Bignotti"],
        "description": "Software development for currency and cryptocurrencys analysis",
        "image": require("./images/maxmin.png").default,
        "technologies": ["Python", "Multiprocessing", "Data Science", "Pandas", "PyQt5", "SCRUM", "Trello", "Slack"],
        "reponame": "trovo",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/maxmin_public/master/README.md",
    },
    {
        "id": 8,
        "name": "Quinsa Mayorista - E-commerce and Marketing Campaigns",
        "autors": ["arre[code]", "Quinsa Team"],
        "description": "Made for a new wholesale clothing enterprise of Argentina",
        "image": require("./images/quinsa.png").default,
        "technologies": ["TiendaNube", "CSS", "Marketing", "Facebook Business", "Instagram"],
        "reponame": "trovo",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/quinsa-mayorista/master/README.md",
    },
    {
        "id": 8,
        "name": "La Reina - Web Page Section",
        "autors": ["arre[code]"],
        "description": "Made for a new wholesale clothing enterprise of Argentina",
        "image": require("./images/lareinalayout.png").default,
        "technologies": ["Bootstrap", "CSS", "Wordpress"],
        "reponame": "trovo",
        "github_readmos": "https://raw.githubusercontent.com/axelromero99/lareina-mayorista-layout/master/README.md",
    },


]